import { ChangeEvent, ReactElement } from 'react'

import { ISelectEmailStatusProps } from 'components/SelectEmailStatus/types'
import { EEmailStatus } from 'models/bookings/types'
import { defineMessages, useIntl } from 'react-intl'
import { safeFormatMessage } from 'utils/intl'
import { Select } from 'components/v2/Select'

const EMAIL_STATUS_LIST = [
  EEmailStatus.BLOCKED,
  EEmailStatus.BOUNCE,
  EEmailStatus.DEFERRED,
  EEmailStatus.DELIVERED,
  EEmailStatus.DROPPED,
  EEmailStatus.PROCESSED,
  EEmailStatus.SENT
]

export const emailStatusMessages = defineMessages({
  [EEmailStatus.BLOCKED]: {
    id: 'emailStatus.blocked',
    defaultMessage: 'Blocked'
  },
  [EEmailStatus.BOUNCE]: {
    id: 'emailStatus.bounce',
    defaultMessage: 'Bounce'
  },
  [EEmailStatus.DEFERRED]: {
    id: 'emailStatus.deferred',
    defaultMessage: 'Deferred'
  },
  [EEmailStatus.DELIVERED]: {
    id: 'emailStatus.delivered',
    defaultMessage: 'Delivered'
  },
  [EEmailStatus.DROPPED]: {
    id: 'emailStatus.dropped',
    defaultMessage: 'Dropped'
  },
  [EEmailStatus.PROCESSED]: {
    id: 'emailStatus.processed',
    defaultMessage: 'Processed'
  },
  [EEmailStatus.SENT]: {
    id: 'emailStatus.sent',
    defaultMessage: 'Sent'
  }
})

export const sanitizeEmailStatus = (emailStatus: string): EEmailStatus | '' => {
  const emailStatusValues = Object.values(EEmailStatus)
  return emailStatusValues.includes(emailStatus as unknown as EEmailStatus) ? (emailStatus as EEmailStatus) : ''
}

export const SelectEmailStatus = ({
  onChange,
  value,
  id,
  label,
  placeholder
}: ISelectEmailStatusProps): ReactElement => {
  const intl = useIntl()

  const handleSelectChange = ({ target: { value } }: ChangeEvent<HTMLSelectElement>): void => {
    onChange(value as EEmailStatus)
  }

  const emailStatusListSorted = [...EMAIL_STATUS_LIST].sort((a, b) =>
    safeFormatMessage({ intl, key: a, messages: emailStatusMessages }).localeCompare(
      safeFormatMessage({ intl, key: b, messages: emailStatusMessages })
    )
  )

  return (
    <Select id={id} value={value} onChange={handleSelectChange} label={label}>
      <option value="">{placeholder}</option>
      {emailStatusListSorted.map((value): ReactElement => {
        return (
          <option value={value} key={value}>
            {safeFormatMessage({ intl, key: value, messages: emailStatusMessages })}
          </option>
        )
      })}
    </Select>
  )
}
